"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _spinner = _interopRequireDefault(require("britive-design-system/core/components/spinner"));

var _table = _interopRequireDefault(require("britive-design-system/core/components/table"));

var _tooltip = _interopRequireDefault(require("britive-design-system/core/components/tooltip"));

var _pill = _interopRequireDefault(require("britive-design-system/core/components/pill"));

var _autocomplete = _interopRequireDefault(require("britive-design-system/core/components/autocomplete"));

var _checkbox = _interopRequireDefault(require("britive-design-system/core/components/checkbox"));

var _editIcon = _interopRequireDefault(require("../../../../../assets/edit-icon.svg"));

var _submitTableRow = _interopRequireDefault(require("../../../../../assets/submit-table-row.svg"));

var _disabledSubmitTableRow = _interopRequireDefault(require("../../../../../assets/disabled-submit-table-row.svg"));

var _action = require("../../../../../components/notification/action");

var _deleteIcon = _interopRequireDefault(require("../../../../../assets/delete-icon.svg"));

var _cancelIcon = _interopRequireDefault(require("../../../../../assets/cancelIcon.svg"));

var _lodash = require("lodash");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _commonUtils = require("../../../../../utils/common-utils");

var _utils = require("../../../../profile-policy/utils");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _actions = require("../../../../policy/resourceLabels/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.resource-labels-tab-main-container {\n  flex-grow: 1;\n  padding-top: 3rem;\n  padding-left: 3.5rem;\n  padding-bottom: 3rem;\n  padding-right: 2rem;\n  overflow: auto; }\n  .resource-labels-tab-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .resource-labels-tab-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .resource-labels-tab-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .resource-labels-tab-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .resource-labels-tab-main-container .labels-table table[name=resource-labels-table] {\n    height: 0; }\n  .resource-labels-tab-main-container .table-cell-checkbox {\n    display: flex;\n    align-items: center; }\n  .resource-labels-tab-main-container .buttons-wrapper {\n    display: flex;\n    gap: 5px;\n    cursor: pointer; }\n";
  var fileName = "compone_resourceLabels";
  var element = document.querySelector("style[data-sass-component='compone_resourceLabels']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var ResourceLabels = function ResourceLabels(_ref) {
  var validationHook = _ref.validationHook,
      consumerEntityId = _ref.consumerEntityId;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    var _state$resourceLabels;

    return state === null || state === void 0 ? void 0 : (_state$resourceLabels = state.resourceLabelsReducer) === null || _state$resourceLabels === void 0 ? void 0 : _state$resourceLabels.resourceLabels;
  }),
      resourceLabels = _useSelector.data,
      labelsLoading = _useSelector.status;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      resourceLabelsList = _useState2[0],
      setResourceLabelsList = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isEditRow = _useState4[0],
      setIsEditRow = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      newValue = _useState6[0],
      setNewValue = _useState6[1];

  var _useState7 = (0, _react.useState)(-1),
      _useState8 = _slicedToArray(_useState7, 2),
      rowToBeEdited = _useState8[0],
      setRowToBeEdited = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      editedValue = _useState10[0],
      setEditedValue = _useState10[1];

  var _useState11 = (0, _react.useState)(''),
      _useState12 = _slicedToArray(_useState11, 2),
      searchLabel = _useState12[0],
      setSearchLabel = _useState12[1];

  var params = {
    page: 0,
    size: 20
  };
  (0, _react.useEffect)(function () {
    fetchResourceLabels(params);
  }, []);

  var fetchResourceLabels = function fetchResourceLabels() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    dispatch((0, _actions.getResourceLabels)(consumerEntityId, params));
  };

  var massageData = function massageData() {
    var _Object$entries, _validationHook$value;

    var resourceList = (_Object$entries = Object.entries((validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value = validationHook.values) === null || _validationHook$value === void 0 ? void 0 : _validationHook$value.resourceLabels) || [])) === null || _Object$entries === void 0 ? void 0 : _Object$entries.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          values = _ref3[1];

      return {
        key: key,
        values: values
      };
    });
    return resourceList;
  };

  var updatePayload = function updatePayload() {
    var resourceLabels = {}; // If isSAProfilePolicyPath() is true, filter items with isChecked: true

    var filteredList = (0, _utils.isSAProfilePolicyPath)() ? resourceLabelsList === null || resourceLabelsList === void 0 ? void 0 : resourceLabelsList.filter(function (item) {
      return item === null || item === void 0 ? void 0 : item.isChecked;
    }) : resourceLabelsList;
    filteredList === null || filteredList === void 0 ? void 0 : filteredList.forEach(function (item) {
      var _item$values;

      resourceLabels[item.key] = (_item$values = item.values) === null || _item$values === void 0 ? void 0 : _item$values.filter(function (value, index) {
        var _item$values2;

        return ((_item$values2 = item.values) === null || _item$values2 === void 0 ? void 0 : _item$values2.indexOf(value)) === index;
      });
    });
    return resourceLabels;
  };

  (0, _react.useEffect)(function () {
    var _validationHook$value2;

    if (!(0, _lodash.isEmpty)(validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value2 = validationHook.values) === null || _validationHook$value2 === void 0 ? void 0 : _validationHook$value2.resourceLabels) && (0, _utils.isResourcePolicyPath)()) {
      setResourceLabelsList(massageData());
    }
  }, []);

  var mergeResourceLabels = function mergeResourceLabels(existingLabels, allLabels) {
    return allLabels === null || allLabels === void 0 ? void 0 : allLabels.map(function (label) {
      var matchingLabel = existingLabels === null || existingLabels === void 0 ? void 0 : existingLabels.find(function (existingLabel) {
        return existingLabel.key === label.key;
      });

      if (!(0, _lodash.isEmpty)(matchingLabel)) {
        return _objectSpread(_objectSpread({}, label), {}, {
          values: matchingLabel.values,
          isChecked: true
        });
      }

      return _objectSpread(_objectSpread({}, label), {}, {
        isChecked: false
      });
    });
  };

  var updateResourceLabelsList = function updateResourceLabelsList() {
    var oldSelectedLabels = massageData();
    var finalLabelsList = mergeResourceLabels(oldSelectedLabels, resourceLabels);
    setResourceLabelsList(finalLabelsList);
  };

  (0, _react.useEffect)(function () {
    var _validationHook$value3;

    // Early return if basic condition is not met
    if (!(0, _utils.isSAProfilePolicyPath)()) return;
    var hasResourceLabels = !(0, _lodash.isEmpty)(resourceLabels);
    var hasValidationLabels = !(0, _lodash.isEmpty)(validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value3 = validationHook.values) === null || _validationHook$value3 === void 0 ? void 0 : _validationHook$value3.resourceLabels);
    var hasResourceLabelsList = !(0, _lodash.isEmpty)(resourceLabelsList); // If resourceLabels is empty, clear the list

    if (!hasResourceLabels) {
      setResourceLabelsList([]);
    }

    if (!hasResourceLabelsList) {
      if (hasValidationLabels) {
        updateResourceLabelsList();
      } else {
        setResourceLabelsList(resourceLabels);
      }
    } else if (!hasValidationLabels) {
      setResourceLabelsList(resourceLabels);
    } else {
      updateResourceLabelsList();
    }
  }, [resourceLabels]);
  (0, _react.useEffect)(function () {
    if (!(0, _lodash.isEmpty)(resourceLabelsList)) {
      validationHook.handleChange(validationHook.names.resourceLabels, updatePayload());
    }
  }, [resourceLabelsList]);
  (0, _react.useEffect)(function () {
    setEditedValue(rowToBeEdited >= 0 ? resourceLabelsList[rowToBeEdited] : null);
  }, [rowToBeEdited]);

  var handleValue = function handleValue(index, editedValue) {
    // Create a copy of the resourceLabelsList array
    var updatedResourceLabelsList = _toConsumableArray(resourceLabelsList); // Update the values array of the object at the specified index


    updatedResourceLabelsList[index] = _objectSpread(_objectSpread({}, updatedResourceLabelsList[index]), {}, {
      values: Array.isArray(editedValue) ? editedValue : (editedValue === null || editedValue === void 0 ? void 0 : editedValue.values) || []
    }); // Update the state with the modified array

    setResourceLabelsList(updatedResourceLabelsList);
  };

  var rowToBeDeleted = function rowToBeDeleted(indexToDelete) {
    // Create a copy of the resourceLabelsList array
    var updatedResourceLabelsList = _toConsumableArray(resourceLabelsList);

    if (indexToDelete > -1 && indexToDelete < updatedResourceLabelsList.length) {
      updatedResourceLabelsList.splice(indexToDelete, 1);
    }

    setResourceLabelsList(updatedResourceLabelsList);
  };

  var onAdd = function onAdd(addedValue) {
    if (resourceLabelsList !== null && resourceLabelsList !== void 0 && resourceLabelsList.find(function (value) {
      return value.key === addedValue.key;
    })) {
      dispatch((0, _action.openNotification)('warning', 'Same key already exists', true, 3000));
      return;
    } // Update the list with the new pair


    setResourceLabelsList(function (prevList) {
      return [].concat(_toConsumableArray(prevList), [addedValue]);
    });
    setNewValue({});
    setSearchLabel('');
    fetchResourceLabels(params);
  };

  var shouldDisableAddingNewRow = function shouldDisableAddingNewRow() {
    if ((0, _lodash.isEmpty)(newValue === null || newValue === void 0 ? void 0 : newValue.key) || (0, _lodash.isEmpty)(newValue === null || newValue === void 0 ? void 0 : newValue.values)) {
      return true;
    }

    return false;
  };

  var handleLabelSearch = function handleLabelSearch(input) {
    setSearchLabel(input);
    if (!(0, _lodash.isEmpty)(newValue)) setNewValue({});

    var updatedParams = _objectSpread(_objectSpread({}, params), {}, {
      searchText: input
    });

    fetchResourceLabels(updatedParams);
  };

  var columns = [{
    field: 'key',
    headerName: 'Label Key',
    width: '400px',
    renderColumn: function renderColumn(row) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell-checkbox"
      }, (0, _utils.isSAProfilePolicyPath)() && /*#__PURE__*/_react.default.createElement(_checkbox.default, {
        checked: row === null || row === void 0 ? void 0 : row.isChecked,
        onChange: function onChange(e) {
          var isItemChecked = e.target.checked;
          var updatedResourceLabelsList = resourceLabelsList === null || resourceLabelsList === void 0 ? void 0 : resourceLabelsList.map(function (item) {
            if (item.key === row.key) {
              return _objectSpread(_objectSpread({}, item), {}, {
                isChecked: isItemChecked
              });
            }

            return item;
          });
          setResourceLabelsList(updatedResourceLabelsList);
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell"
      }, row === null || row === void 0 ? void 0 : row.key));
    }
  }, {
    headerName: 'Values',
    renderColumn: function renderColumn(row, value, index) {
      var _resourceLabels$find, _resourceLabels$find$, _resourceLabels$find2, _resourceLabels$find3, _row$values;

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isEditRow && index === rowToBeEdited ? /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell-autocomplete"
      }, /*#__PURE__*/_react.default.createElement(_autocomplete.default, {
        width: "412px",
        multiple: true,
        options: !(0, _utils.isResourcePolicyPath)() ? resourceLabels === null || resourceLabels === void 0 ? void 0 : (_resourceLabels$find = resourceLabels.find(function (obj) {
          return obj.key === (row === null || row === void 0 ? void 0 : row.key);
        })) === null || _resourceLabels$find === void 0 ? void 0 : (_resourceLabels$find$ = _resourceLabels$find.values) === null || _resourceLabels$find$ === void 0 ? void 0 : _resourceLabels$find$.map(function (value) {
          return value;
        }) : (resourceLabels === null || resourceLabels === void 0 ? void 0 : (_resourceLabels$find2 = resourceLabels.find(function (obj) {
          return obj.keyName === (row === null || row === void 0 ? void 0 : row.key);
        })) === null || _resourceLabels$find2 === void 0 ? void 0 : (_resourceLabels$find3 = _resourceLabels$find2.values) === null || _resourceLabels$find3 === void 0 ? void 0 : _resourceLabels$find3.map(function (value) {
          return value.name;
        })) || [],
        value: row === null || row === void 0 ? void 0 : row.values,
        onChange: function onChange(event, value) {
          return setEditedValue(value);
        },
        getOptionLabel: function getOptionLabel(option) {
          return option;
        }
      })) : /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell"
      }, row === null || row === void 0 ? void 0 : (_row$values = row.values) === null || _row$values === void 0 ? void 0 : _row$values.map(function (value) {
        return /*#__PURE__*/_react.default.createElement(_pill.default, {
          readOnly: true,
          label: value,
          key: value
        });
      })));
    }
  }, {
    headerName: 'Action',
    width: '100px',
    renderColumn: function renderColumn(row, value, index) {
      return index === rowToBeEdited ? /*#__PURE__*/_react.default.createElement("div", {
        className: "buttons-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: 'Save',
        position: "top"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _submitTableRow.default,
        height: "25",
        onClick: function onClick() {
          handleValue(index, editedValue);
          setRowToBeEdited(-1);
          setIsEditRow(false);
        }
      })), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: 'Cancel',
        position: "top"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _cancelIcon.default,
        onClick: function onClick() {
          setRowToBeEdited(-1);
          setIsEditRow(false);
        }
      }))) : /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell"
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: "Edit",
        position: "top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "action-button"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _editIcon.default,
        width: "24",
        onClick: function onClick() {
          setRowToBeEdited(index), setIsEditRow(true);
        }
      }))), !(0, _utils.isSAProfilePolicyPath)() && /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: "Delete",
        position: "top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "action-button",
        onClick: function onClick() {
          return rowToBeDeleted(index);
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _deleteIcon.default
      }))));
    }
  }];
  var columnsForNewRow = [{
    width: '400px',
    // eslint-disable-next-line react/display-name
    renderColumn: function renderColumn() {
      return /*#__PURE__*/_react.default.createElement(_autocomplete.default, {
        width: "300px",
        height: "55px",
        options: resourceLabels || [{}],
        value: (0, _lodash.isEmpty)(newValue === null || newValue === void 0 ? void 0 : newValue.key) ? [{
          keyName: searchLabel
        }] : [{
          keyName: newValue === null || newValue === void 0 ? void 0 : newValue.key
        }],
        onChange: function onChange(e, value) {
          setSearchLabel('');
          setNewValue(_objectSpread(_objectSpread({}, newValue), {}, {
            key: value === null || value === void 0 ? void 0 : value.keyName,
            values: []
          }));
        },
        getOptionLabel: function getOptionLabel(option) {
          return option === null || option === void 0 ? void 0 : option.keyName;
        },
        onInputChange: (0, _debounce.default)(function (_, value) {
          return handleLabelSearch(value);
        }, 300),
        filterCurrentValueFromOptions: true,
        showOptionsOnBlur: true
      });
    }
  }, {
    // eslint-disable-next-line react/display-name
    renderColumn: function renderColumn() {
      var _resourceLabels$find4, _resourceLabels$find5;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell-autocomplete"
      }, /*#__PURE__*/_react.default.createElement(_autocomplete.default, {
        width: "412px",
        multiple: true,
        disabled: (0, _lodash.isEmpty)(newValue === null || newValue === void 0 ? void 0 : newValue.key),
        options: (newValue === null || newValue === void 0 ? void 0 : newValue.key) && (resourceLabels === null || resourceLabels === void 0 ? void 0 : (_resourceLabels$find4 = resourceLabels.find(function (obj) {
          return obj.keyName === newValue.key;
        })) === null || _resourceLabels$find4 === void 0 ? void 0 : (_resourceLabels$find5 = _resourceLabels$find4.values) === null || _resourceLabels$find5 === void 0 ? void 0 : _resourceLabels$find5.map(function (value) {
          return value.name;
        })) || [],
        value: newValue === null || newValue === void 0 ? void 0 : newValue.values,
        onChange: function onChange(e, value) {
          setNewValue(_objectSpread(_objectSpread({}, newValue), {}, {
            values: value
          }));
        },
        getOptionLabel: function getOptionLabel(option) {
          return option;
        }
      }), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: shouldDisableAddingNewRow() ? 'Please select new key and value' : 'Add',
        position: "right"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: shouldDisableAddingNewRow() ? _disabledSubmitTableRow.default : _submitTableRow.default,
        height: "25",
        onClick: function onClick() {
          if (shouldDisableAddingNewRow()) {
            return;
          }

          !(0, _lodash.isEmpty)(newValue) && onAdd(newValue);
        }
      })));
    }
  }];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _commonUtils.isLoading)(labelsLoading) && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "medium",
    message: "Loading...",
    overlay: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.mainContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "labels-table"
  }, /*#__PURE__*/_react.default.createElement(_table.default, {
    resizableColumns: true,
    columns: columns,
    rows: resourceLabelsList || [],
    addNewRow: (0, _utils.isResourcePolicyPath)(),
    columnsForNewRow: columnsForNewRow,
    name: "resource-labels-table"
  }))));
};

ResourceLabels.propTypes = {
  validationHook: _propTypes.default.object,
  consumerEntityId: _propTypes.default.string
};
var _default = ResourceLabels;
exports.default = _default;